import { gql } from 'urql';

export const UpdateCustomerAddresses = gql`
  mutation UpdateCustomerAddresses(
    $addressInputs: [CustomerAddressInput!]
    $channelType: AddressChangeChannelInput!
    $challengeId: IdempotencyToken
    $isMailingAddressDifferentThanResidential: Boolean
  ) {
    updateCustomerAddresses(
      input: {
        addressInputs: $addressInputs
        channelType: $channelType
        challengeId: $challengeId
        isMailingAddressDifferentThanResidential: $isMailingAddressDifferentThanResidential
      }
    ) {
      __typename
      ... on UpdateCustomerAddressesSuccess {
        customerInfo {
          email {
            address
          }
        }
        successMessage: message
        challenges {
          challengeId
          challengeType
          challengeState
          createdAt
          expiresAt
        }
      }
      ... on UpdateCustomerAddressesDeclined {
        declineMessage
      }
      ... on UpdateCustomerAddressesError {
        code
        title
        message
      }
    }
  }
`;
